import React from "react";
import styled from "styled-components";

export const NavigationItem = ({ label, isActive, badge, isFirst, isLast, onClick }) => {
    return (
        <ItemContainer isActive={isActive} isFirst={isFirst} isLast={isLast} onClick={onClick}>
            <div style={{position: "relative"}}>
                {label}
                {badge && <Badge>{badge}</Badge>}
            </div>
        </ItemContainer>
    );
}

const ItemContainer = styled.div`
  border-radius: ${props => props.isFirst ? "8px 0 0 8px" : props.isLast ? "0 8px 8px 0" : "0"};
  background-color: ${props => props.isActive ? "#2CB2DC" : "transparent"};
  color: ${props => props.isActive ? "#FFFFFF" : "#2CB2DC"};
  padding-block: 16px;
  font: 500 20px Roboto;
  letter-spacing: 0.7px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  border: ${props => !props.isActive ? "2px solid #1CC4E8" : "none"};
  cursor: pointer;
  width: 100%;
`;

const Badge = styled.span`
  color: #8fd14f;
  padding: 0 2px;
  font: 500 16px Roboto;
  letter-spacing: 0.7px;
  position: absolute;
  top: -4px;
`;


// WEBPACK FOOTER //
// ./src/containers/DashboardNavigation/NavigationItem.js